/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessReviewSession', 'model/BusinessReviewSessionPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/BusinessReviewSession'), require('../model/BusinessReviewSessionPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.BusinessReviewSessionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessReviewSession, root.ForStractionServiceApi.BusinessReviewSessionPaginationSlice);
  }
}(this, function(ApiClient, BusinessReviewSession, BusinessReviewSessionPaginationSlice) {
  'use strict';

  /**
   * BusinessReviewSession service.
   * @module api/BusinessReviewSessionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new BusinessReviewSessionApi. 
   * @alias module:api/BusinessReviewSessionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the businessReviewSessionEditPut operation.
     * @callback module:api/BusinessReviewSessionApi~businessReviewSessionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/BusinessReviewSession} body 
     * @param {module:api/BusinessReviewSessionApi~businessReviewSessionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessReviewSessionEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewSessionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessReviewSessionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessReviewSession/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewSessionFinishSessionGet operation.
     * @callback module:api/BusinessReviewSessionApi~businessReviewSessionFinishSessionGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * finishSession
     * @param {String} _4SAPIAppID 
     * @param {Integer} sessionID 
     * @param {Integer} endStatusID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.comment  (default to )
     * @param {module:api/BusinessReviewSessionApi~businessReviewSessionFinishSessionGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.businessReviewSessionFinishSessionGet = function(_4SAPIAppID, sessionID, endStatusID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewSessionFinishSessionGet";
      }

      // verify the required parameter 'sessionID' is set
      if (sessionID == undefined || sessionID == null) {
        throw "Missing the required parameter 'sessionID' when calling businessReviewSessionFinishSessionGet";
      }

      // verify the required parameter 'endStatusID' is set
      if (endStatusID == undefined || endStatusID == null) {
        throw "Missing the required parameter 'endStatusID' when calling businessReviewSessionFinishSessionGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sessionID': sessionID,
        'endStatusID': endStatusID,
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/BusinessReviewSession/finishSession', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewSessionLoadGet operation.
     * @callback module:api/BusinessReviewSessionApi~businessReviewSessionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessReviewSession} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/BusinessReviewSessionApi~businessReviewSessionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessReviewSession}
     */
    this.businessReviewSessionLoadGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewSessionLoadGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling businessReviewSessionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = BusinessReviewSession;

      return this.apiClient.callApi(
        '/BusinessReviewSession/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessReviewSessionSearchSlicePut operation.
     * @callback module:api/BusinessReviewSessionApi~businessReviewSessionSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessReviewSessionPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/BusinessReviewSession} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {module:api/BusinessReviewSessionApi~businessReviewSessionSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessReviewSessionPaginationSlice}
     */
    this.businessReviewSessionSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling businessReviewSessionSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling businessReviewSessionSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = BusinessReviewSessionPaginationSlice;

      return this.apiClient.callApi(
        '/BusinessReviewSession/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
